import { HousekeepingViewPermissions } from '@hkm/components/Housekeeping/shared/config/housekeepingViewPermissionsConfig';
import { Permission } from '@hkm/shared/permissions/enum/Permission';
import { PermissionConjunction } from '@hkm/shared/permissions/enum/PermissionConjunction';
import { PermissionsConfig } from '@hkm/shared/permissions/types/permissionsConfig';

export const HousekeepingStatisticsPermissions = [
  ...HousekeepingViewPermissions,
  Permission.HousekeepingViewSummary
] as const;

export const HousekeepingStatisticsPermissionsConfig: PermissionsConfig = [
  HousekeepingStatisticsPermissions,
  PermissionConjunction.All
];



// WEBPACK FOOTER //
// ./src/components/Housekeeping/Statistics/config/housekeepingStatisticsPermissionsConfig.ts